import React from 'react';

export interface IProps {
  fillColor?: string;
}

const LoopIcon: React.FC<IProps> = (props) => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.8428 12.0809L9.65834 8.8981C10.4561 7.92449 10.8936 6.70616 10.8936 5.44792C10.8936 2.44332 8.44972 0 5.44744 0C4.71349 0 4.00082 0.143646 3.32936 0.428279C2.68051 0.703601 2.09814 1.09597 1.5982 1.59607C1.09826 2.09617 0.704697 2.67874 0.429466 3.32781C0.144928 3.99949 0 4.7124 0 5.44659C0 8.4512 2.44384 10.8945 5.44611 10.8945C6.70526 10.8945 7.92186 10.4569 8.89514 9.65889L12.0769 12.8417C12.1793 12.9441 12.3149 13 12.4585 13C12.6034 13 12.7391 12.9441 12.8401 12.8417C13.0529 12.6329 13.0529 12.2911 12.8428 12.0809ZM9.81523 5.44659C9.81523 7.85666 7.85538 9.81584 5.44744 9.81584C3.03817 9.81584 1.07965 7.85533 1.07965 5.44659C1.07965 3.03786 3.0395 1.07735 5.44744 1.07735C7.85538 1.07735 9.81523 3.03786 9.81523 5.44659Z" fill={props.fillColor ?? "black"} />
    </svg>
  )
}

export default LoopIcon;